export default __webpack_public_path__ + "static/media/full-fleet-visual.8e7ac2a5.png";